import React from "react";

export default function SQL_WHERE() {
  return (
    <div className="p-4">
      <h1 className="text-2xl font-bold">SQL_WHERE</h1>
      <p>This is the SQL_WHERE component generated from the SQL JSON.</p>
    </div>
  );
}
